import React from 'react';
import {
    KatButton,
    KatCard,
    KatLink
} from '@amzn/katal-react';

import forge from 'node-forge';
import * as constants from '../appConstants';

import ApiContent from './api/ApiContent';
import AuthenticationContent from './AuthenticationContent';
import ButtonContent from './payButton/ButtonContent';
import ScratchpadHeader from './ScratchpadHeader';
import ScratchpadFooter from './ScratchpadFooter';
import { EventHandler, CustomEventHandler } from '../utils/customEventHandler'
import Welcome from './Welcome';

import './App.scss';

/*
    Enum to store left navigation menu items
*/
export enum MenuItem {
    WELCOME = "welcome",
    AUTHENTICATION = "authentication",
    API = "apiContent",
    PAYBUTTON = "buttonContent"
  };

const apiTypes = [
    constants.ApiType.CREATE_CHECKOUT_SESSION,
    constants.ApiType.GET_CHECKOUT_SESSION,
    constants.ApiType.UPDATE_CHECKOUT_SESSION,
    constants.ApiType.COMPLETE_CHECKOUT_SESSION,
    constants.ApiType.GET_CHARGE_PERMISSION,
    constants.ApiType.UPDATE_CHARGE_PERMISSION,
    constants.ApiType.CLOSE_CHARGE_PERMISSION,
    constants.ApiType.GET_CHARGE,
    constants.ApiType.CREATE_CHARGE,
    constants.ApiType.CAPTURE_CHARGE,
    constants.ApiType.CANCEL_CHARGE,
    constants.ApiType.CREATE_REFUND,
    constants.ApiType.GET_REFUND,
    constants.ApiType.DELIVERY_TRACKER,
    constants.ApiType.GET_BUYER,
    constants.ApiType.GET_REPORTS,
    constants.ApiType.GET_REPORT_BY_ID,
    constants.ApiType.CREATE_REPORT,
    constants.ApiType.GET_REPORT_DOCUMENT
];

export class ScratchpadApp extends React.Component {
    eventHandler: CustomEventHandler;

    state = {
        menuItem: MenuItem.WELCOME,
        apiType: "createCheckoutSession"
    };

    authValues = {
        region: constants.hostMapping[window.location.hostname] || "eu",
        publicKeyId: '',
        privateKey: {} as forge.pki.rsa.PrivateKey,
        authToken: ''
    }

    constructor(props: Readonly<{ apiSchema: any, authValues: any; }>) {
        super(props);
        this.eventHandler = EventHandler;
    }

    componentDidMount() {
       EventHandler.subscribe('authEvent', (event) => {
            this.authValues.region = event.detail.region;
            this.authValues.publicKeyId = event.detail.publicKeyId;
            this.authValues.privateKey = event.detail.privateKey;
            this.authValues.authToken = event.detail.authToken;
       });
    }

    apiPanel(id: string) {
        // switch to and render the new screen
        this.setState({
            apiType: id,
            menuItem: MenuItem.API
        });

        // clear API Resquest and API Response panels when user selects different API
        const options = {
                outputHeaders: '',
                payload: '',
                canonicalRequest: '',
                stringToSign: '',
                status: '',
                requestId: '',
                responseBody: ''
        };
        this.eventHandler.emit('apiEvent', options);
    }

    apiLinks = apiTypes.map((apiType) => (
        <p key={apiType}>
            <KatLink onClick={(e) => this.apiPanel(apiType)}>{apiType}</KatLink>
        </p>
    ));

    render() {
        return (
            <>
            <ScratchpadHeader region = {this.authValues.region} />

            <div id="Scratchpad_content">
                <div id="Scratchpad_content_left">
                    <KatButton   label="Welcome"
                        variant="primary"
                        id="welcomeButton"
                        onClick = { (e) => this.setState({menuItem:MenuItem.WELCOME})} /><br/>
                    <KatButton   label="Authentication"
                        variant="primary"
                        id="authButton"
                        onClick = { (e) => this.setState({menuItem:MenuItem.AUTHENTICATION}) } /><br/>
                    <KatButton   label="API"
                        variant="primary"
                        id="apiButton"
                        onClick = {(e) => this.setState({menuItem:MenuItem.API}) } /><br/>
                    <KatCard id="menuButton">
                        {this.apiLinks}
                    </KatCard>
                    <KatButton
                        label="Button Code"
                        variant="primary"
                        id="payButton"
                        onClick = { (e) => this.setState({menuItem:MenuItem.PAYBUTTON}) }>
                    </KatButton>
                </div>

                <div id="Scratchpad_content_right">
                    { this.state.menuItem === MenuItem.WELCOME && <Welcome/> }
                    { this.state.menuItem === MenuItem.AUTHENTICATION && <AuthenticationContent authValues = {this.authValues} /> }
                    { this.state.menuItem === MenuItem.API && <ApiContent apiSchema = {this.state.apiType} authValues = {this.authValues} /> }
                    { this.state.menuItem === MenuItem.PAYBUTTON && <ButtonContent authValues = {this.authValues} /> }
                </div>
            </div>
            <ScratchpadFooter region = {this.authValues.region} />
            </>
        );
    }
}
export default ScratchpadApp;
